import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { SimpleForm, useDataProvider } from "react-admin";
import { SchoolIdSelected } from "utils/tools";
import AssignmentSummaryBox from "./AssignmentSummaryBox";
import CustomDatePickerInput from "./CustomDatePickerInput";
import { GridinRowsWithSpace } from "utils/style";
import AssignmentReportButton from "./AssignmentReportButton";
import { availableOnlySuperAdmin } from "utils/validation";

const useStyles = makeStyles({
  waveTitle: {
    fontSize: "18px",
    marginBottom: 10,
  },
  formContainer: {
    "& .MuiCardContent-root": {
      paddingLeft: 0,
    },
  },
  waveWrapper: {
    padding: "6px 16px 30px 16px",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: 10,
    marginBottom: 20,
  },
});

const TotalNoOfAssignmentsComponent = () => {
  const [busSchedulePlans, setBusSchedulePlans] = useState<IBusSchedulePlans[]>(
    [],
  );
  const [busScheduleIds, setBusScheduleIds] = useState<number[]>([]);
  const [busSchedulePlansWithWaveName, setBusSchedulePlansWithWaveName] =
    useState<any>([]);
  const [startDate, setStartDate] = useState<string>(
    moment().format("yyyy-MM-DD"),
  );
  const [endDate, setEndDate] = useState<string>(moment().format("yyyy-MM-DD"));

  const provider = useDataProvider();
  const classes = useStyles();
  const schoolId = SchoolIdSelected();

  useEffect(() => {
    if (schoolId) {
      provider
        .getList("busSchedulePlans", {
          filter: { SchoolId: Number(schoolId) },
          pagination: {
            page: 1,
            perPage: 1000,
          },
          sort: {
            field: "Id",
            order: "ASC",
          },
        })
        .then((result) => {
          setBusSchedulePlans(result.data as IBusSchedulePlans[]);
          setBusScheduleIds([]);
          setBusSchedulePlansWithWaveName([]);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolId]);

  useEffect(() => {
    if (busSchedulePlans.length > 0) {
      let tempBusScheduleIds: number[] = [];
      busSchedulePlans.forEach((busSchedulePlan: IBusSchedulePlans) =>
        tempBusScheduleIds.push(busSchedulePlan.busScheduleId),
      );

      setBusScheduleIds((value) => [...value, ...tempBusScheduleIds]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busSchedulePlans]);

  useEffect(() => {
    if (busScheduleIds.length === 0) {
      setBusSchedulePlansWithWaveName([]);
      return;
    }

    if (busScheduleIds.length === busSchedulePlans.length) {
      provider
        .getMany("busSchedules", { ids: busScheduleIds })
        .then(({ data }) => {
          busSchedulePlans.forEach((busSchedulePlan: any) => {
            data.forEach((busSchedule) => {
              if (busSchedulePlan.busScheduleId === busSchedule.id) {
                busSchedulePlan.waveName = busSchedule.name;
                busSchedulePlan.busScheduleType = busSchedule.type;
              }
            });
          });

          setBusSchedulePlansWithWaveName(busSchedulePlans);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busScheduleIds]);

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12} style={GridinRowsWithSpace}>
          <Typography variant="h6" gutterBottom>
            Total No. Of Assignments
          </Typography>

          {busSchedulePlansWithWaveName.length > 0 && availableOnlySuperAdmin() ? (
            <AssignmentReportButton
              provider={provider}
              busSchedulePlansWithWaveName={busSchedulePlansWithWaveName}
              startDate={startDate}
              endDate={endDate}
            />
          ) : (
            <> </>
          )}
        </Grid>
      </SanitizedGrid>

      <SimpleForm toolbar={null} className={classes.formContainer}>
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12} md={4}>
            <CustomDatePickerInput
              label="Start Date"
              value={startDate}
              setValue={setStartDate}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <CustomDatePickerInput
              label="End Date"
              value={endDate}
              setValue={setEndDate}
            />
          </Grid>
        </SanitizedGrid>
      </SimpleForm>

      {busSchedulePlansWithWaveName.length > 0 ? (
        <>
          {busSchedulePlansWithWaveName.map((busSchedulePlan: any) => {
            return (
              <Box className={classes.waveWrapper}>
                <Typography
                  className={classes.waveTitle}
                  variant="h6"
                  align="left"
                >
                  {busSchedulePlan.waveName}
                </Typography>

                <AssignmentSummaryBox
                  busSchedulePlanId={busSchedulePlan.id}
                  busScheduleType={busSchedulePlan.busScheduleType}
                  startDate={startDate}
                  endDate={endDate}
                />
              </Box>
            );
          })}
        </>
      ) : (
        <Typography className={classes.waveTitle} variant="h6" align="left">
          This School doesn't have any active wave
        </Typography>
      )}
    </>
  );
};

export default TotalNoOfAssignmentsComponent;
